import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/DependencyTree.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.some.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useMemo } from 'react';
import { useStore } from 'effector-react';
import '@gmini/ui-kit/lib/tree-styles.css';
import { useShiftKeyPressed } from '@gmini/utils/lib/useShiftKeyPressed';
import { isNotEmpty } from '@gmini/utils';
import { isReferenceNode, isBimNode, isAssemblyClassifierNode } from "../../classifier-service/Node";
import { getNode } from "../../classifier-service";
import { TreeContext } from "../ClassifierTree/TreeContext";
import { buildKeyByPath, findInFlatTree, getParentsByPath, getRefFromPathKey, getClassifierInfo, findFlatParents, findFlatChildren } from "../ClassifierTree/utils";
import { VirtualizedTree } from "../ClassifierTree/VirtualizedTree";
import { Breadcrumbs } from "../ClassifierTree/Breadcrumbs";
import { TreeContextMenuProvider } from "../ClassifierTree/TreeContextMenu/ctx";
import { Icon } from "../ContextMenuItem";
import { RemoveDependencyDialog } from "../RemoveDependencyDialog";
import { useReadonlyMode } from "../../hooks";
import { useContextMenu } from "../../components/VersionSwitch/ContextMenu";
import { EditorTreeRoot } from "./EditorTree.styled";
import { fetchChildren } from "./fetchChildren";
import { NodeContainer } from "./NodeContainer/NodeContainer";
import { filterNotExpandedTree } from "./createTree";
import { UpdateDialog } from "./nodes/common/UpdateDialog";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var DependencyTree = function DependencyTree(_ref) {
  var _ctxMenu$item;

  var nodes$ = _ref.nodes$,
      currentEntity = _ref.currentEntity,
      renderNodeLayout = _ref.renderNodeLayout,
      selectedFromOtherTreeCount = _ref.selectedFromOtherTreeCount,
      onFindAnywhere = _ref.onFindAnywhere,
      onDelete = _ref.onDelete,
      treeModel = _ref.treeModel,
      checkedModel = _ref.checkedModel,
      expandModel = _ref.expandModel,
      onPending = _ref.onPending,
      selectedPath = _ref.selectedPath,
      notify = _ref.notify,
      onLoadInclusion = _ref.onLoadInclusion,
      isIncluded = _ref.isIncluded,
      disableOperations = _ref.disableOperations,
      showModelVersion = _ref.showModelVersion,
      searchSourceData$ = _ref.searchSourceData$,
      hideCtxMenu = _ref.hideCtxMenu,
      searchMatched$ = _ref.searchMatched$,
      dynamicGroupsConditions = _ref.dynamicGroupsConditions,
      errorNode = _ref.errorNode,
      sources = _ref.sources,
      selectedSourceNodes$ = _ref.selectedSourceNodes$,
      openedFilterPanel$ = _ref.openedFilterPanel$;
  var nodes = useStore(nodes$, {
    loc: {
      file: _effectorFileName,
      line: 165,
      column: 16
    },
    name: "DependencyTree",
    sid: "DependencyTree /src/classifier-editor/DependencyTree/DependencyTree.tsx [165, 16]"
  });
  var selectedSourceNodes = useStore(selectedSourceNodes$, {
    loc: {
      file: _effectorFileName,
      line: 166,
      column: 30
    },
    name: "DependencyTree",
    sid: "DependencyTree /src/classifier-editor/DependencyTree/DependencyTree.tsx [166, 30]"
  });
  var countChecked = selectedSourceNodes.length;
  var shiftKeyPressed = useShiftKeyPressed();
  var openedFilterPanel = useStore(openedFilterPanel$, {
    loc: {
      file: _effectorFileName,
      line: 169,
      column: 28
    },
    name: "DependencyTree",
    sid: "DependencyTree /src/classifier-editor/DependencyTree/DependencyTree.tsx [169, 28]"
  });

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      updateDialogOpen = _React$useState2[0],
      setUpdateDialogOpen = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      removeDialogOpen = _React$useState4[0],
      setRemoveDialogOpen = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      highlightItem = _React$useState6[0],
      setHighlightItem = _React$useState6[1];

  var _useReadonlyMode = useReadonlyMode(),
      readonlyMode = _useReadonlyMode.readonlyMode;

  var _useContextMenu = useContextMenu([{
    title: 'Свернуть все',
    icon: Icon.COLLAPSE,
    onClick: function onClick() {
      expandModel.resetExpanded();
    }
  }, {
    title: 'Найти везде',
    icon: Icon.SEARCH,
    onClick: function onClick(_ref2) {
      var ref = _ref2.ref,
          path = _ref2.path;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onFindAnywhere(ref, path);
    },
    show: function show(_ref3) {
      var ref = _ref3.ref;
      var node = getNode(nodes$.getState(), ref);

      if (node && isAssemblyClassifierNode(node)) {
        return !!node.assemblyModelRef;
      }

      if (node && isReferenceNode(node)) {
        var bimNode = getNode(nodes$.getState(), node.element);
        return !((bimNode === null || bimNode === void 0 ? void 0 : bimNode.type) === 'BimModelNode' && bimNode.status !== 'ImportCompleted');
      }

      return !!(node && isBimNode(node));
    }
  }, {
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        children: ["\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B (", countChecked, ")"]
      }), /*#__PURE__*/_jsx("div", {
        children: "\u0432 \u043E\u0431\u043B\u0430\u0441\u0442\u044C \u043F\u043E\u0438\u0441\u043A\u0430 \u0444\u0438\u043B\u044C\u0442\u0440\u0430"
      })]
    }),
    icon: Icon.CREATE_FILTER,
    onClick: function onClick() {
      sources === null || sources === void 0 ? void 0 : sources.add(selectedSourceNodes);
    },
    show: function show() {
      return !!sources && !!countChecked && openedFilterPanel.open;
    }
  }, {
    title: 'Удалить',
    icon: Icon.DELETE,
    onClick: function onClick(_ref4) {
      var _node$assemblyModelRe;

      var ref = _ref4.ref,
          path = _ref4.path;

      var _node = getNode(nodes$.getState(), ref);

      if (!_node) {
        throw new Error("[deleteNode]: cannot find node with type:".concat(ref.type, ", id: ").concat(ref.id));
      }

      var assemblyElement = isAssemblyClassifierNode(_node) ? ((_node$assemblyModelRe = _node.assemblyModelRef) === null || _node$assemblyModelRe === void 0 ? void 0 : _node$assemblyModelRe.element) || null : null;
      var element = isReferenceNode(_node) ? _node.element : assemblyElement;
      var node = element ? getNode(nodes$.getState(), element) : _node;
      var key = buildKeyByPath(path);

      if (node) {
        var classifierInfo = getClassifierInfo(node, function () {
          var parents = path.length === 1 ? path.map(function (key) {
            return getNode(nodes$.getState(), getRefFromPathKey(key));
          }).filter(isNotEmpty) : getParentsByPath(nodes$.getState(), path);
          var assembly = parents.find(isAssemblyClassifierNode);
          return (assembly === null || assembly === void 0 ? void 0 : assembly.assemblyModelRef) || parents.find(isReferenceNode) || null;
        });
        var included = isIncluded === null || isIncluded === void 0 ? void 0 : isIncluded(key, classifierInfo.sourceClassifierId);

        if (included !== null && included !== void 0 && included.length) {
          setRemoveDialogOpen({
            name: node.name,
            type: (node === null || node === void 0 ? void 0 : node.type) === 'BimModelNode' ? node.modelType : node.type,
            node: _node
          });
        } else {
          onRemoveNode(_node);
        }
      }
    },
    show: function show(_ref5) {
      var ref = _ref5.ref,
          path = _ref5.path;
      return !disableOperations && !readonlyMode.enabled && (ref.type === 'BimModelReferenceNode' && path.length <= 1 || ref.type === 'UserClassifierNode' || ref.type === 'AssemblyClassifierNode' || ref.type === 'AnonymousClassifierNode');
    }
  }]),
      ContextMenu = _useContextMenu.ContextMenu,
      setCtxMenu = _useContextMenu.setCtxMenu,
      ctxMenu = _useContextMenu.ctxMenu;

  var onHighlightItem = React.useCallback(function (item) {
    setHighlightItem(item.path);
    setTimeout(function () {
      return setHighlightItem(null);
    }, 1000);
  }, []);
  var expanded = useStore(expandModel.expanded$, {
    loc: {
      file: _effectorFileName,
      line: 312,
      column: 19
    },
    name: "DependencyTree",
    sid: "DependencyTree /src/classifier-editor/DependencyTree/DependencyTree.tsx [312, 19]"
  });
  var checked = useStore(checkedModel.checked$, {
    loc: {
      file: _effectorFileName,
      line: 313,
      column: 18
    },
    name: "DependencyTree",
    sid: "DependencyTree /src/classifier-editor/DependencyTree/DependencyTree.tsx [313, 18]"
  });
  var onRemoveNode = React.useCallback(function (node) {
    if (!onDelete) {
      return;
    }

    if (node.type === 'UserClassifierNode' || node.type === 'AssemblyClassifierNode' || node.type === 'AnonymousClassifierNode') {
      onDelete(_objectSpread({
        sourceClassifierId: node.id,
        type: node.type
      }, currentEntity));
    }

    if (node.type === 'BimModelReferenceNode') {
      onDelete(_objectSpread({
        sourceClassifierId: node.parentClassifierId,
        type: node.type
      }, currentEntity));
    }

    setRemoveDialogOpen(false);
  }, [currentEntity, onDelete]);
  useEffect(function () {
    return expandModel.resetExpanded();
  }, [expandModel]);
  var flatTree = useStore(treeModel.flatTree$, {
    loc: {
      file: _effectorFileName,
      line: 346,
      column: 19
    },
    name: "DependencyTree",
    sid: "DependencyTree /src/classifier-editor/DependencyTree/DependencyTree.tsx [346, 19]"
  });
  var flatVisibleTree = useMemo(function () {
    return filterNotExpandedTree({
      tree: flatTree,
      expanded: expanded
    });
  }, [expanded, flatTree]);
  var itemRenderer = useCallback(function (_ref6) {
    var item = _ref6.item;
    var key = buildKeyByPath(item.path);
    var isExpanded = expanded[key];
    var isChecked = !!checked[key];
    var parents = findFlatParents(flatTree, item.path);
    var someParentChecked = parents.some(function (item) {
      return !!checked[buildKeyByPath(item.path)];
    });
    var children = findFlatChildren(flatTree, item.path);
    var someChildChecked = children.some(function (item) {
      return !!checked[buildKeyByPath(item.path)];
    });
    return /*#__PURE__*/_jsx(NodeContainer // key={key}
    , {
      item: item,
      isExpanded: isExpanded,
      searchMatched$: searchMatched$,
      nodes$: nodes$,
      renderNodeLayout: renderNodeLayout,
      clsDependenciesRefs: currentEntity.sourceClassifiers,
      checkbox: {
        checked: isChecked || someParentChecked,
        indeterminate: someChildChecked,
        disabled: someParentChecked
      },
      highlightItem: highlightItem,
      onUpdateDialogOpen: setUpdateDialogOpen,
      toggle: function toggle(n, path) {
        var nextExpanded = !isExpanded;
        expandModel.setItemExpanded({
          key: key,
          value: nextExpanded
        });

        if (nextExpanded) {
          fetchChildren({
            node: n,
            currentClassifierData: n.type === 'UserClassifierGroupNode' || n.type === 'DynamicGeneratedGroupNode' ? {
              id: n.parentClassifierId,
              version: n.parentClassifierVersion
            } : currentEntity,
            key: buildKeyByPath(item.path),
            dynamicMode: false
          });

          if (onLoadInclusion && n.type === 'BimStandardSizeNode') {
            var classifierInfo = getClassifierInfo(n, function () {
              var parents = getParentsByPath(nodes$.getState(), path);
              var assembly = parents.find(isAssemblyClassifierNode);
              return (assembly === null || assembly === void 0 ? void 0 : assembly.assemblyModelRef) || parents.find(isReferenceNode) || null;
            });
            onLoadInclusion({
              modelVersion: classifierInfo.sourceClassifierVersion,
              standardSizeId: n.id
            });
          }
        }
      },
      onLoadMore: function onLoadMore(n, offset, key) {
        fetchChildren({
          node: n,
          currentClassifierData: n.type === 'DynamicGeneratedGroupNode' || n.type === 'UserClassifierGroupNode' ? {
            id: n.parentClassifierId,
            version: n.parentClassifierVersion
          } : currentEntity,
          offset: offset,
          dynamicMode: false,
          key: key
        });
      },
      onChecked: function onChecked(value) {
        // !!!!! Если изменится структура дерева - нужно полностью сбросить выделение, т.к. будет неконсистентность в состоянии
        checkedModel.onChecked({
          children: children,
          flatTree: flatVisibleTree,
          key: key,
          value: value,
          shiftKeyPressed: shiftKeyPressed
        });
      },
      onPending: onPending,
      selectedPath: selectedPath,
      showModelVersion: showModelVersion,
      searchSourceData$: searchSourceData$,
      error: errorNode
    });
  }, [expanded, checked, flatTree, searchMatched$, nodes$, renderNodeLayout, currentEntity, highlightItem, onPending, selectedPath, showModelVersion, searchSourceData$, errorNode, expandModel, onLoadInclusion, checkedModel, flatVisibleTree, shiftKeyPressed]);
  var breadcrumbsRenderer = useCallback(function (_ref7) {
    var breadCrumbData = _ref7.breadCrumbData,
        scrollTo = _ref7.scrollTo;
    return /*#__PURE__*/_jsx(Breadcrumbs, {
      nodes$: nodes$,
      breadCrumbData: breadCrumbData,
      scrollTo: scrollTo
    });
  }, [nodes$]);
  useEffect(function () {
    return function () {
      return checkedModel.resetChecked();
    };
  }, [checkedModel]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(TreeContextMenuProvider, {
      value: {
        onOpen: function onOpen(coords, path) {
          var item = findInFlatTree(flatTree, path);

          if (!item) {
            throw new Error('Item not found in flat tree');
          }

          if (item.ref.type === 'LoadMore') {
            return;
          }

          setCtxMenu({
            item: {
              ref: item.ref,
              path: path
            },
            coords: coords
          });
        },
        path: (_ctxMenu$item = ctxMenu.item) === null || _ctxMenu$item === void 0 ? void 0 : _ctxMenu$item.path,
        hideCtxMenu: hideCtxMenu
      },
      children: [/*#__PURE__*/_jsx(TreeContext.Provider, {
        value: {
          dynamicGroupsConditions: dynamicGroupsConditions,
          nodes: nodes,
          tree: flatTree
        },
        children: /*#__PURE__*/_jsx(EditorTreeRoot, {
          children: /*#__PURE__*/_jsx(VirtualizedTree, {
            rowHeight: function rowHeight(node) {
              return node.path.length === 1 ? 34 : 30;
            },
            flatTree: flatVisibleTree,
            itemRenderer: itemRenderer,
            breadcrumbsRenderer: breadcrumbsRenderer,
            onHighlightItem: onHighlightItem
          })
        })
      }), /*#__PURE__*/_jsx(ContextMenu, {})]
    }), updateDialogOpen && /*#__PURE__*/_jsx(UpdateDialog, {
      modelName: updateDialogOpen.modelName,
      sourceClassifierId: updateDialogOpen.sourceClassifierId,
      modelType: updateDialogOpen.modelType,
      currentClassifier: currentEntity,
      onClose: function onClose() {
        return setUpdateDialogOpen(false);
      },
      disabled: readonlyMode.enabled || !!disableOperations
    }), removeDialogOpen && /*#__PURE__*/_jsx(RemoveDependencyDialog, {
      name: removeDialogOpen.name,
      type: removeDialogOpen.type,
      onClose: function onClose() {
        return setRemoveDialogOpen(false);
      },
      removeDependency: function removeDependency() {
        return onRemoveNode(removeDialogOpen.node);
      }
    })]
  });
};